module.exports = __webpack_public_path__ + "img/newsletter-background.be3b79e8.png";